import { Button, Eyebrow, SurfaceRow } from '../../../../components/ui'
import type { TestCategory } from './types'

interface TestsCategoryFilterProps {
  categories: TestCategory[]
  selectedCategory: TestCategory
  onSelectCategory: (category: TestCategory) => void
}

export function TestsCategoryFilter({
  categories,
  selectedCategory,
  onSelectCategory,
}: TestsCategoryFilterProps) {
  return (
    <SurfaceRow className="tests-filter-shell mt-4">
      <Eyebrow variant="section" tone="subtle">Filter by category</Eyebrow>
      <div className="tests-filter-row">
        {categories.map((category) => (
          <Button
            key={category}
            type="button"
            variant="chip"
            onClick={() => onSelectCategory(category)}
            data-active={selectedCategory === category ? 'true' : undefined}
          >
            {category}
          </Button>
        ))}
      </div>
    </SurfaceRow>
  )
}
